import SubmissionError from "../../../../error/SubmissionError";
import fetch from "../../../../utils/fetch";
import * as types from "./mutation_types";
import { Feed } from "../../../../interfaces/feed"

export const reset = ({ commit }) => {
  commit(types.RESET);
};

export const retrieve = ({ commit, state, rootState }, id: any) => {
  commit(types.TOGGLE_LOADING);

  // START:CUSTOM - generated
  let token = rootState.auth.token;
  let options = {};
  // END:CUSTOM - generated

  return fetch("feeds/" + id, options, token)
    .then((response) => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING);
      commit(types.SET_RETRIEVED, data);
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING);
      commit(types.SET_ERROR, e.message);
    });
};

export const update = ({ commit, state, rootState }, payload:Feed) => {
  commit(types.SET_ERROR, "");
  commit(types.TOGGLE_LOADING);

  // START:CUSTOM - generated
  let token = rootState.auth.token;
  // END:CUSTOM - generated

  return fetch(
    state.retrieved["@id"],
    {
      method: "PUT",
      headers: new Headers({ "Content-Type": "application/ld+json" }),
      body: JSON.stringify(payload),
    },
    token
  )
    .then((response) => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING);
      commit(types.SET_UPDATED, data);
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING);

      if (e instanceof SubmissionError) {
        commit(types.SET_VIOLATIONS, e.errors);
        // eslint-disable-next-line
        commit(types.SET_ERROR, e.errors._error);

        return;
      }

      // eslint-disable-next-line
      commit(types.SET_ERROR, e.message);
    });
};

export const updateRetrieved = ({ commit }, updated:Feed) => {
  commit(types.UPDATE_RETRIEVED, updated);
};
